import { useEffect, useState } from 'react';
import CancelIcon from '../../../../../assets/svg/DesignIcons/cancelicon';
import { CompanyInformation } from '../../../../pages/contactpage/Model/ContactPageModel';


const OpenInfoView = ({ Expand, isMobile }) => {
    const [moveUp, setMoveUp] = useState(false);
    const [isClosing, setIsClosing] = useState(false);


    useEffect(() => {
        const timer = setTimeout(() => {
            setMoveUp(true);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    const handleCancelClick = () => {
        if (!isMobile) {
            setMoveUp(false);

            setTimeout(() => {
                setIsClosing(true);
                setTimeout(() => {
                    Expand();
                }, 1000);
            }, 1000);
        }
    };

    return (
        <div className={`contact-page-view-container-comapny-profile-container-open ${isClosing ? 'slide-out' : ''}`}>
            <div className='contact-page-view-container-comapny-profile-container-top-open'></div>

            <div className='contact-page-view-container-comapny-profile-container-middle-open'>
                <div className={`moving-svg-wrapper ${moveUp ? 'move-up' : ''}`}>
                    <CancelIcon onClick={handleCancelClick} />
                </div>
                <div className='contact-page-company-contact-container'>
                    <div className='contact-page-company-contact-container-wrapup'>
                        <span className='contact-page-info-text'>Info</span>
                        {CompanyInformation?.map((value, index) => (
                            <div className='individual-contact-info' key={index}>
                                <div className='individual-contact-info-svg-part'>
                                    {value?.icon}
                                </div>
                                <div className='individual-contact-info-content-part'>
                                    <span className='contact-page-info-text-sub'>{value?.details}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='contact-page-view-container-comapny-profile-container-bottom-open'></div>
        </div>
    );
};

export default OpenInfoView;
